import {jsonMember, jsonObject} from 'typedjson';

@jsonObject
export class ExamResponse {
    @jsonMember
    answerId: number;
    @jsonMember
    questionId: number;
}
